import type { AddToCart } from "../../../cbi-generator/generated/dto/AddToCart";
import type { ProductListing } from "@/api/models/shop/ProductListing";
import type { DonationPurchaseDetails } from "../../../cbi-generator/generated/dto/DonationPurchaseDetails";

export function buildMemberPurchase(
  item: ProductListing,
  amountCents: number,
  donation: DonationPurchaseDetails | null = null,
): AddToCart {
  const amount = item.allowPriceOverride ? amountCents : item.priceCents;
  if (amount == null || !Number.isSafeInteger(amount) || amount <= 0)
    throw new Error("Enter an amount greater than zero.");
  if (
    item.allowPriceOverride &&
    ((item.priceOverrideMin != null && amount < item.priceOverrideMin) ||
      (item.priceOverrideMax != null && amount > item.priceOverrideMax))
  )
    throw new Error("Enter an amount within the allowed range.");
  return {
    itemInstance: { assignId: item.instanceId },
    person: null,
    quantity: 1,
    specifiedAmountCents: item.allowPriceOverride ? amount : null,
    parent: null,
    options: { cardNum: null, balanceNumber: null, membership: null, donation },
    updateLine: null,
  };
}
